import React, { useState } from 'react'
import SearchCheckbox from '../../search/SearchCheckbox/SearchCheckbox.jsx'
import FullScreenModal from '../../shared_components/FullScreenModal/FullScreenModal.jsx'
import mapImg from './map_icon.svg'
import listImg from './list_icon.svg'
import filterImg from './filter_icon_white.svg'
import './FilterRibbon.scss'

const FilterRibbon = ({
  lexicon,
  searchTerms,
  updateSearchTerms,
  isMobileMapOpen,
  toggleMobileMap,
}) => {
  // are-you-sure-you-want-to-clear dialogue
  const [clearDialogOpen, setClearDialogOpen] = useState(false)
  const [mobileFilterModalOpen, setMobileFilterModalOpen] = useState(false)

  return (
    <div className="FilterRibbon">
      {clearDialogOpen && (
        // TODO: eslint (react/jsx-no-undef): ConfirmDialog, really not defined anywhere, dead code?
        // eslint-disable-next-line react/jsx-no-undef
        <ConfirmDialog
          titleText={lexicon.subset('modal').get('confirm_clear_title')}
          contentText={lexicon.subset('modal').get('confirm_clear_content')}
          cancelText={lexicon.subset('modal').get('cancel_clear')}
          confirmText={lexicon.subset('modal').get('confirm_clear_button')}
          onCancel={() => setClearDialogOpen(false)}
          // TODO: eslint (no-undef): onDesktopDialogConfirm, pretty sure this is dead code
          // eslint-disable-next-line no-undef
          onConfirm={onDesktopDialogConfirm}
        />
      )}

      {/* MOBILE BUTTONS : OPEN FILTERS, SWITCH TO MAP */}
      <div className="white-button-bar mobile">
        <button type="button" onClick={() => setMobileFilterModalOpen(true)}>
          <img src={filterImg} alt="filter-icon" />
          {lexicon.get('filters')}
        </button>

        <button type="button" onClick={toggleMobileMap}>
          {isMobileMapOpen ? (
            <>
              <img src={listImg} alt="list-icon" />
              {lexicon.get('list')}
            </>
          ) : (
            <>
              <img src={mapImg} alt="map-icon" />
              {lexicon.get('map')}
            </>
          )}
        </button>
      </div>

      {/* DESKTOP BUTTONS */}
      <div className="white-button-bar desktop">
        <div className="filter-by">{lexicon.get('filter_by')}</div>

        <SearchCheckbox
          value={searchTerms.filterImplant}
          setValue={(value) => updateSearchTerms({ filterImplant: value })}
          label={lexicon.get('implant_label')}
        />

        <SearchCheckbox
          value={searchTerms.filterIUD}
          setValue={(value) => updateSearchTerms({ filterIUD: value })}
          label={lexicon.get('iud_label')}
        />
      </div>

      {mobileFilterModalOpen && (
        <FullScreenModal
          setIsModalOpen={setMobileFilterModalOpen}
          closeText={lexicon.get('apply')}
          header={lexicon.get('filters')}
          id="ClinicFinderFilterModal"
        >
          <div className="modal-subpanel">
            <div className="filter-by">{lexicon.get('filter_by')}</div>

            <SearchCheckbox
              value={searchTerms.filterImplant}
              setValue={(value) => updateSearchTerms({ filterImplant: value })}
              label={lexicon.get('implant_label')}
            />

            <SearchCheckbox
              value={searchTerms.filterIUD}
              setValue={(value) => updateSearchTerms({ filterIUD: value })}
              label={lexicon.get('iud_label')}
            />
          </div>
        </FullScreenModal>
      )}
    </div>
  )
}

export default FilterRibbon
